import { apiClient, handleResp } from './utils';
import { empty } from '@/utils';
export default {
  careVideo: {
    getAll() {
      return handleResp(apiClient().get('/care_videos'));
    },
    get(videoSlug) {
      return handleResp(apiClient().get('/care_videos/' + videoSlug));
    },
    create(data) {
      return handleResp(apiClient().post('/admin_create_care_video', data));
    },
    update(videoId, data) {
      return handleResp(apiClient().post('/admin_update_care_video?id=' + videoId, data));
    },
    delete(videoId) {
      return handleResp(apiClient().post('/destroy_care_video?id=' + videoId));
    },
  },
  careCategory: {
    getAll() {
      return handleResp(apiClient().get('/care_categories'));
    },
    get(videoSlug) {
      return handleResp(apiClient().get('/care_categories/' + videoSlug));
    },
    create(data) {
      return handleResp(apiClient().post('/admin_create_care_category', data));
    },
    update(videoId, data) {
      return handleResp(apiClient().post('/admin_update_care_category?id=' + videoId, data));
    },
    delete(videoId) {
      return handleResp(apiClient().post('/destroy_care_category?id=' + videoId));
    },
  },
  careSpeakerBio: {
    getAll() {
      return handleResp(apiClient().get('/care_speaker_bios'));
    },
    get(speakerBioSlug) {
      return handleResp(apiClient().get('/care_speaker_bios/' + speakerBioSlug));
    },
    create(data) {
      return handleResp(apiClient().post('/admin_create_care_speaker_bio', data));
    },
    update(speakerBioId, data) {
      return handleResp(apiClient().post('/admin_update_care_speaker_bio?id=' + speakerBioId, data));
    },
    delete(speakerBioId) {
      return handleResp(apiClient().post('/destroy_care_speaker_bio?id=' + speakerBioId));
    },
  },
  testimonials: {
    getAll() {
      return handleResp(apiClient().get('/testimonials'));
    },
    getByCategory(id) {
      return handleResp(apiClient().get('/testimonials_by_category?id=' + id));
    },
    getBySlug(slug) {
      return handleResp(apiClient().get('/testimonials_by_slug?slug=' + slug));
    },
    get(id) {
      return handleResp(apiClient().post('/find_testimonial?id=' + id));
    },
    create(dataInput) {
      return handleResp(apiClient().post('/admin_create_testimonial', dataInput));
    },
    update(dataInput) {
      return handleResp(apiClient().post('/admin_update_testimonial', dataInput));
    },
    delete(id) {
      return handleResp(apiClient().post('/admin_delete_testimonial?id=' + id));
    },
  },
  answer: {
    getAll() {
      return handleResp(apiClient().get('/answers'));
    },
    get(answerSlug) {
      return handleResp(apiClient().get('/answers/' + answerSlug));
    },
    create(data) {
      return handleResp(apiClient().post('/admin_create_answer', data));
    },
    update(answerId, data) {
      return handleResp(apiClient().post('/admin_update_answer?id=' + answerId, data));
    },
    delete(answerId) {
      return handleResp(apiClient().post('/destroy_answer?id=' + answerId));
    },
  },
  category: {
    getAll() {
      return handleResp(apiClient().get('/categories'));
    },
    get(categorySlug) {
      return handleResp(apiClient().get('/categories/' + categorySlug));
    },
    create(data) {
      return handleResp(apiClient().post('/admin_create_category', data));
    },
    update(categoryId, data) {
      return handleResp(apiClient().post('/admin_update_category?id=' + categoryId, data));
    },
    delete(categoryId) {
      return handleResp(apiClient().post('/destroy_category?id=' + categoryId));
    },
  },
  location: {
    get(query = '') {
      return handleResp(apiClient().get('/locations' + (empty(query) ? '' : '?query=' + query)));
    },
    update(locationId, data) {
      return handleResp(apiClient().post('/updatethe_location?id=' + locationId, data));
    },
    delete(locationId) {
      return handleResp(apiClient().post('/destroy_location?id=' + locationId));
    },
  },
  user: {
    getAll(params = {}) {
      return handleResp(apiClient().get('/list_users', { params }));
    },
    getPasterAll(params = {}) {
      console.log(params);
      return handleResp(apiClient().get('/list_pasters', { params }));
    },
    getAllWithoutStory(params = {}) {
      return handleResp(apiClient().get('/list_users_without_story', { params }));
    },
    getAllWithoutOrderCards(params = {}) {
      return handleResp(apiClient().get('/list_users_without_order_cards', { params }));
    },
    getAllWithoutChurchConnection(params = {}) {
      return handleResp(apiClient().get('/list_users_without_church_connection', { params }));
    },
    update(userId, data) {
      return handleResp(apiClient().post('/user_details_update?id=' + userId, data));
    },
    delete(userId) {
      return handleResp(apiClient().post('/destroy_user?id=' + userId));
    },
    sendLink(hook_key) {
      return handleResp(apiClient().post('/paster_signup_notification?hook_key=' + hook_key));
    },
    restrict(userId, currentId) {
      return handleResp(apiClient().post('/restrict_user?id=' + userId + '&user_id=' + currentId));
    },
    showNotice(userId, currentId) {
      return handleResp(apiClient().post('/show_notice?id=' + userId + '&user_id=' + currentId));
    },
    syncDB(index) {
      return handleResp(apiClient().post('/update_db_by_membership_status?count=' + index));
    },
    getUserInfo() {
      return handleResp(apiClient().post('/lookup_user'));
    },
    setCardAmount(userId, amount) {
      return handleResp(apiClient().post('/users/set_card_amount?id=' + userId, { amount }));
    },
  },
  moderator: {
    getAll() {
      return handleResp(apiClient().get('/moderator_users'));
    },
    getActivities(activity) {
      return handleResp(apiClient().get('/moderator_activities' + (activity ? '?activity=' + activity : '')));
    },
    update(moderatorId, data) {
      return handleResp(apiClient().put('/moderators/' + moderatorId, data));
    },
    delete(moderatorId) {
      return handleResp(apiClient().delete('/moderators/' + moderatorId));
    },
  },
  account: {
    create(data) {
      return handleResp(apiClient().post('/admin_account_setup', data));
    },
    getAll(params = {}) {
      return handleResp(apiClient().get('/accounts', { params }));
    },
    get(accountId) {
      return handleResp(apiClient().get('/accounts/' + accountId));
    },
    getLocation(accountId) {
      return handleResp(apiClient().post('/account_locations?id=' + accountId));
    },
    update(accountId, data) {
      return handleResp(apiClient().post('/update_account?id=' + accountId, data));
    },
    delete(accountId) {
      return handleResp(apiClient().post('/destroy_account?id=' + accountId));
    },
    getUser(accountId) {
      return handleResp(apiClient().post('/account_users?id=' + accountId));
    },
  },
  pages: {
    getAll() {
      return handleResp(apiClient().get('/pages'));
    },
    create(data) {
      return handleResp(apiClient().post('/admin_create_page', data));
    },
    update(pageId, data) {
      return handleResp(apiClient().post('/admin_update_page?id=' + pageId, data));
    },
    delete(pageId) {
      return handleResp(apiClient().delete('/pages/' + pageId));
    },
  },
  monthlyPages: {
    getAll() {
      return handleResp(apiClient().get('/monthly_videos'));
    },
    create(data) {
      return handleResp(apiClient().post('/monthly_videos', data));
    },
    update(pageId, data) {
      return handleResp(apiClient().put('/monthly_videos/' + pageId, data));
    },
    delete(pageId) {
      return handleResp(apiClient().delete('/monthly_videos/' + pageId));
    },
  },
  aiControl: {
    get() {
      return handleResp(apiClient().get('/ai_control'));
    },
    update(data) {
      return handleResp(apiClient().post('/ai_control', data));
    },
  },
  videos: {
    getAll() {
      return handleResp(apiClient().get('/intro_videos'));
    },
    getQrAll() {
      return handleResp(apiClient().get('/intro_qrs'));
    },
    getShareStory() {
      return handleResp(apiClient().get('/share_story_videos'));
    },
    update(videoId, data) {
      return handleResp(apiClient().put('/intro_videos/' + videoId, data));
    },
    delete(videoId) {
      return handleResp(apiClient().delete('/intro_videos/' + videoId + '/delete'));
    },
  },
  post: {
    getAll() {
      return handleResp(apiClient().get('/posts'));
    },
    create(data) {
      return handleResp(apiClient().post('/admin_create_post', data));
    },
    update(postId, data) {
      return handleResp(apiClient().post('/admin_update_post?id=' + postId, data));
    },
    delete(postId) {
      return handleResp(apiClient().post('/posts/destroy?id=' + postId));
    },
  },
  store: {
    getProducts(params = {}) {
      return handleResp(apiClient({ apiVer: 2 }).get('/products', { params }));
    },
    getCategories(params = {}) {
      return handleResp(apiClient({ apiVer: 2 }).get('/product_categories', { params }));
    },
    getProduct(id) {
      return handleResp(apiClient({ apiVer: 2 }).get('/products/' + id));
    },
    getCategory(id) {
      return handleResp(apiClient({ apiVer: 2 }).get('/product_categories/' + id));
    },
    createProduct(params) {
      return handleResp(apiClient({ apiVer: 2 }).post('/products', { product: params }));
    },
    createCategory(params) {
      return handleResp(apiClient({ apiVer: 2 }).post('/product_categories', { category: params }));
    },
    updateProduct(id, params) {
      return handleResp(apiClient({ apiVer: 2 }).put('/products/' + id, { ...params }));
    },
    updateCategory(id, params) {
      return handleResp(apiClient({ apiVer: 2 }).put('/product_categories/' + id, { ...params }));
    },
    deleteProduct(id) {
      return handleResp(apiClient({ apiVer: 2 }).delete('/products/' + id));
    },
    deleteCategory(id) {
      return handleResp(apiClient({ apiVer: 2 }).delete('/product_categories/' + id));
    },
  },
  cardOrder(userId) {
    return {
      getAllCards() {
        return handleResp(apiClient().post('/show_card_orders'));
      },
      getOrdersAll() {
        return handleResp(apiClient().get('/show_card_orders_all'));
      },
      getOrdersNew() {
        return handleResp(apiClient().get('/show_card_orders_new'));
      },
      getOrdersHistory() {
        return handleResp(apiClient().get('/show_card_orders_history'));
      },
      getCardOrder(id) {
        return handleResp(
          apiClient().post('/show_card_order', {
            user_id: userId,
            id,
          }),
        );
      },
      proofChanges(id, request) {
        return handleResp(
          apiClient().post('/card_order_proof_changes', {
            id,
            request,
          }),
        );
      },
      uploadProof(id, proof) {
        return handleResp(
          apiClient().post('/upload_proof', {
            id,
            proof,
          }),
        );
      },
      approveCards(id, approvalSignature) {
        return handleResp(
          apiClient().post('/approve_cards', {
            id,
            approval_signature: approvalSignature,
          }),
        );
      },
      beginDesign(id) {
        return handleResp(
          apiClient().post('/begin_design', {
            id,
          }),
        );
      },
      updateStatus(id, status) {
        return handleResp(
          apiClient().post('/update_card_order_status', {
            user_id: userId,
            id,
            status,
          }),
        );
      },
      doUpdateTracking(id, dataInput) {
        return handleResp(
          apiClient().post('/add_tracking', {
            ...dataInput,
            user_id: userId,
            id,
          }),
        );
      },
      reOrderCard(dataInput) {
        return handleResp(apiClient().post('/re_order_cards', dataInput));
      },
    };
  },
  shareStory() {
    return {
      getAll() {
        return handleResp(apiClient().get('/stories'));
      },
      delete(userId, storyId) {
        return handleResp(
          apiClient().post('/admin_delete_story', {
            id: storyId,
            user_id: userId,
          }),
        );
      },
      approve(storyId) {
        return handleResp(
          apiClient().post('/approve_story', {
            id: storyId,
          }),
        );
      },
      flag(storyId) {
        return handleResp(
          apiClient().post('/flag_story', {
            id: storyId,
          }),
        );
      },
    };
  },
};
